import Vue from 'vue';
import {Component, Model, Prop} from 'vue-property-decorator';
import './radio.scss';

@Component({
             template: `
<span>
  <span ref="ripples"></span>
  <label class="radio-wrapper">
    <span class="radio-floating">
      <input class="radio" @change="onChange" ref="checkbox" @click="addRipple" type="radio" :checked="currentValue === value" :name="name"/>
      <span></span>
    </span>
    <slot></slot>
  </label>
</span>
           `})
export class RadioComponent extends Vue {
  @Prop()
  name: string;

  @Prop()
  value: string;

  @Model('change')
  @Prop()
  currentValue: string;

  ripples = [];

  addRipple() {
    const ripple = document.createElement('div');
    ripple.className = 'ripple';
    if (!this.value) {
      ripple.className += ' red';
    }
    (<HTMLElement>this.$refs.ripples).appendChild(ripple);
    setTimeout(() => { try { (<HTMLElement>this.$refs.ripples).removeChild(ripple) } catch(e) {}}, 1000);
  }

  onChange(event) {
    this.$emit('change', this.value);
  }
}

Vue.component('radio', RadioComponent);



// WEBPACK FOOTER //
// ./src/components/radio/radio.ts